import styled from "styled-components";
import LocationFilterDropdown from "../../../../components/locationFilterDropdown";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state/store";
import { BsPrinterFill } from "react-icons/bs";
import { useBSDashboardContext } from "../../hooks/useBSDashboardContext";
import DateRangePicker from "../../../../components/dateRangePicker";
import { media } from "../../../../helpers/responsive";

const BSContentHeader = () => {
  const companyLocations = useSelector((state: RootState) => state.locations);
  const { disablePrint, handlePrint, selectedDateTimeString } = useBSDashboardContext();
  return (
    <Wrapper>
      <div className="row">
        <div className="col">
          <h1>Business Summary</h1>
        </div>
        <div className="col d-flex justify-content-end align-items-center controls-col">
          {companyLocations.length > 0 && <LocationFilterDropdown />}
          <div className="datepicker-print-row">
            <DateRangePicker />
            <button
              title={
                disablePrint
                  ? "Please wait until all widgets are loaded to print this document"
                  : "Print Report"
              }
              className="btn btn-primary bs-print-btn"
              disabled={disablePrint}
              onClick={handlePrint}>
              <BsPrinterFill fontSize={"20px"} />
            </button>
          </div>
        </div>
      </div>
      <div className="period">
        <span className="date-period">
          <strong>Period:{" "}</strong>
          {selectedDateTimeString}
        </span>
      </div>
    </Wrapper>
  );
};
export { BSContentHeader };

const Wrapper = styled.div`
  padding-left: 50px;
  top: 70px;
  margin: 5px;
  background-color: ${({ theme }) => theme.body};
  transition: all 0.25s linear 0s;

  margin: 50px 0 5px;
  width: 100%;
  padding-right: 50px;
  h1 {
    font-weight: 800;
    margin-bottom: 0;
  }
  .dashboard-link {
    cursor: pointer;
    .navigation-arrow {
      position: absolute;
      left: 30px;
    }
    h3 {
      margin-bottom: 0;
      font-weight: 500;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .bs-print-btn {
    margin-left: 10px;
    border: none;
    &:disabled {
      background-color: grey;
    }
  }
  .datepicker-print-row {
    display: flex;
    align-items: center;
  }

  /* ═══ 2-ROW (<1024px) ═══
     Row 1: Title (left)
     Row 2: Location + Datepicker + Export (right) */
  @media (max-width: 1023px) {
    padding-left: 24px;
    padding-right: 24px;
    margin: 25px 0 5px;

    h1 {
      font-size: 28px;
    }

    .row {
      flex-direction: column;
      .controls-col {
        justify-content: flex-end !important;
        flex-wrap: nowrap;
        gap: 8px;
        margin-top: 10px;
      }
    }
  }

  /* ═══ 4-ROW (<720px) ═══
     Row 1: Title (left)
     Row 2: Location (full width)
     Row 3: Datepicker (full width)
     Row 4: Print button (right aligned) */
  @media (max-width: 719px) {
    padding-left: 16px;
    padding-right: 16px;
    margin: 15px 0 5px;

    h1 {
      font-size: 22px;
    }

    .row {
      .controls-col {
        flex-wrap: wrap;
        justify-content: flex-start !important;

        > .location-select-control {
          flex: 1 1 100%;
        }

        > .datepicker-print-row {
          flex: 1 1 100%;
          min-width: 0;
          flex-wrap: wrap;

          > .date-range-select-control {
            flex: 1 1 100%;
            width: 100%;
            .date-range-select-toggle { width: 100%; min-width: auto; }
          }

          > .bs-print-btn {
            margin-left: auto;
            margin-top: 8px;
          }
        }
      }
    }
  }
`;
